"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "reggello": {
    "3900b108": [{
      "hkey": "97a77449",
      "slug": "ciliegi-prulli-pian-di-rona",
      "name": "Ciliegi-Prulli-Pian di Rona",
      "primary": true,
      "skipSearch": false
    }],
    "i-ciliegi": [{
      "hkey": "97a77449",
      "slug": "ciliegi-prulli-pian-di-rona",
      "name": "Ciliegi-Prulli-Pian di Rona",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "reggello"
    }],
    "e11d51d1": [{
      "hkey": "97a77449",
      "slug": "ciliegi-prulli-pian-di-rona",
      "name": "Ciliegi-Prulli-Pian di Rona",
      "primary": true,
      "skipSearch": false
    }],
    "ciliegi": [{
      "hkey": "97a77449",
      "slug": "ciliegi-prulli-pian-di-rona",
      "name": "Ciliegi-Prulli-Pian di Rona",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "reggello"
    }],
    "640f9c0a": [{
      "hkey": "8ef9bc20",
      "slug": "reggello",
      "name": "Reggello",
      "primary": true,
      "skipSearch": false
    }],
    "bigazzi": [{
      "hkey": "8ef9bc20",
      "slug": "reggello",
      "name": "Reggello",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "889b906a": [{
      "hkey": "554f05a1",
      "slug": "cancelli-poggio-ai-giubbiani",
      "name": "Cancelli-Poggio ai Giubbiani",
      "primary": true,
      "skipSearch": false
    }],
    "cancelli": [{
      "hkey": "554f05a1",
      "slug": "cancelli-poggio-ai-giubbiani",
      "name": "Cancelli-Poggio ai Giubbiani",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "60124b22": [{
      "hkey": "8ef9bc20",
      "slug": "reggello",
      "name": "Reggello",
      "primary": true,
      "skipSearch": false
    }],
    "cetina": [{
      "hkey": "8ef9bc20",
      "slug": "reggello",
      "name": "Reggello",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "598d5692": [{
      "hkey": "8ef9bc20",
      "slug": "reggello",
      "name": "Reggello",
      "primary": true,
      "skipSearch": false
    }],
    "industriale-reggello": [{
      "hkey": "8ef9bc20",
      "slug": "reggello",
      "name": "Reggello",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "ea8a5cb3": [{
      "hkey": "6e5831f2",
      "slug": "leccio-case-nuove",
      "name": "Leccio-Case Nuove",
      "primary": true,
      "skipSearch": false
    }],
    "leccio": [{
      "hkey": "6e5831f2",
      "slug": "leccio-case-nuove",
      "name": "Leccio-Case Nuove",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "f5bbe29e": [{
      "hkey": "605b4bc9",
      "slug": "matassino",
      "name": "Matassino",
      "primary": true,
      "skipSearch": false
    }],
    "matassino-viesca": [{
      "hkey": "605b4bc9",
      "slug": "matassino",
      "name": "Matassino",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "fadf388f": [{
      "hkey": "9627f7e9",
      "slug": "montanino",
      "name": "Montanino",
      "primary": true,
      "skipSearch": false
    }],
    "montanino-prulli": [{
      "hkey": "9627f7e9",
      "slug": "montanino",
      "name": "Montanino",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "8193f752": [{
      "hkey": "8ef9bc20",
      "slug": "reggello",
      "name": "Reggello",
      "primary": true,
      "skipSearch": false
    }],
    "poderino": [{
      "hkey": "8ef9bc20",
      "slug": "reggello",
      "name": "Reggello",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "c1afe8a3": [{
      "hkey": "554f05a1",
      "slug": "cancelli-poggio-ai-giubbiani",
      "name": "Cancelli-Poggio ai Giubbiani",
      "primary": true,
      "skipSearch": false
    }],
    "poggio-giubbiani": [{
      "hkey": "554f05a1",
      "slug": "cancelli-poggio-ai-giubbiani",
      "name": "Cancelli-Poggio ai Giubbiani",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "reggello"
    }],
    "02625029": [{
      "hkey": "8ef9bc20",
      "slug": "reggello",
      "name": "Reggello",
      "primary": true,
      "skipSearch": false
    }],
    "pontifogno": [{
      "hkey": "8ef9bc20",
      "slug": "reggello",
      "name": "Reggello",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "31b10094": [{
      "hkey": "97a77449",
      "slug": "ciliegi-prulli-pian-di-rona",
      "name": "Ciliegi-Prulli-Pian di Rona",
      "primary": true,
      "skipSearch": false
    }],
    "rona": [{
      "hkey": "97a77449",
      "slug": "ciliegi-prulli-pian-di-rona",
      "name": "Ciliegi-Prulli-Pian di Rona",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "4a1ec7df": [{
      "hkey": "8ef9bc20",
      "slug": "reggello",
      "name": "Reggello",
      "primary": true,
      "skipSearch": false
    }],
    "setteponti": [{
      "hkey": "8ef9bc20",
      "slug": "reggello",
      "name": "Reggello",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "909490c8": [{
      "hkey": "8ef9bc20",
      "slug": "reggello",
      "name": "Reggello",
      "primary": true,
      "skipSearch": false
    }],
    "sociana": [{
      "hkey": "8ef9bc20",
      "slug": "reggello",
      "name": "Reggello",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "2a2deadf": [{
      "hkey": "7c8312e5",
      "slug": "vaggio",
      "name": "Vaggio",
      "primary": true,
      "skipSearch": false
    }],
    "vaggio-la-canova": [{
      "hkey": "7c8312e5",
      "slug": "vaggio",
      "name": "Vaggio",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;